import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Box from "@material-ui/core/Box";
import { useSearchParams } from "react-router-dom";
import { useWorkOrdersContext } from "../context/workOrdersContext";
import { cmmsTheme } from "@setup/theme/cmms-theme";

type Props = {};

export const TypesFilter = ({}: Props) => {
	const { state } = useWorkOrdersContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const type = searchParams.get("type") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("type", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box>
			<FormControl variant="outlined" margin="dense" fullWidth>
				<InputLabel id="types-select-label">Types</InputLabel>
				<Select
					labelId="types-select-label"
					id="types-select"
					value={type}
					onChange={handleFilter}
					label="Types"
					style={cmmsTheme.styles.filterSelect}
				>
					{state.typeCodes.map((type) => {
						return (
							<MenuItem key={`logId-${type.id}`} value={type.id}>
								<Grid container alignItems="center">
									{type.description}
								</Grid>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
